import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { installMobileViewportLock } from './utils/mobileViewportLock'

if (import.meta.env.DEV && window.location.hostname === "127.0.0.1" && window.location.port === "3000") {
  const redirectUrl = new URL(window.location.href);
  redirectUrl.hostname = "localhost";
  window.location.replace(redirectUrl.toString());
}

installMobileViewportLock()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
